import React from "react";
import {Slide, ToastContainer } from 'react-toastify';
const Footer = () => {
    return(<>
        <div className="footer-wrap">
            <footer>Copyright &copy; 2026 All rights reserved</footer>
        </div>
        <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            transition={Slide}
            />
    </>);
}

export default Footer;